"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Steps = void 0;
const Steps = {
  IntendedCredit: 'intended-credit-step',
  SelectProduct: 'select-product-step',
  ProductInstallments: 'product-installments-step'
};
exports.Steps = Steps;